import { useEffect, useState } from 'react';

/**
 * Hook to debounce a value and only run on the last invocation
 * @param value
 * @param delay
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (value) {
      timer = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
